<template>
  <div class="profile">
    <template v-if="$auth.loggedIn">
      <nuxt-link :to="localePath(WEB_ROUTES.PROFILE)" class="sf-fr profile-link">
        <user class="profile__icon sf-mr-xs"/>
        {{ $t('header.profile') }}
      </nuxt-link>
      <nuxt-link :to="localePath(WEB_ROUTES.PROFILE_MY_LOAN)" class="sf-fr my-loan-link">
        <wallet class="profile__icon sf-mr-xs"/>
        {{ $t('header.my-loan') }}
      </nuxt-link>
      <div v-qa="'logout_link'" class="sf-fr logout-link" @click="logout">
        <logout class="profile__icon sf-mr-xs"/>
        {{ $t('header.logout') }}
      </div>
    </template>

    <template v-else>
      <nuxt-link :to="localePath(WEB_ROUTES.LOGIN)" class="sf-fr login-link">
        <user class="profile__icon sf-mr-xs"/>
        {{ $t('header.login') }}
      </nuxt-link>
    </template>
  </div>
</template>

<script>
import Wallet from '~/static/img/profile/wallet.svg';
import User from '~/static/img/profile/user.svg';
import Logout from '~/static/img/profile/logout.svg';
import { WEB_ROUTES } from '@/utils/webConfig';
import { DISPATCH_API } from '~/utils/webConfig';

export default {
  components: { Logout, Wallet, User },
  computed: {
    WEB_ROUTES() {
      return WEB_ROUTES;
    },
  },
  methods: {
    logout() {
      this.$auth.logout();
      this.$store.dispatch(DISPATCH_API.CLEAR_PROMO_CODE);
      this.$cookies.remove('promoCode');
      this.$router.push('/login');
    },
  },
};
</script>

<style lang="scss" scoped>
.profile {
  & > * {
    white-space: nowrap;
    color: map-get($map: $colors, $key: text);
    transition: all 0.3s;

    @include not-desktop {
      margin-bottom: 30px;
      font-weight: 700;
    }

    @include desktop {
      padding: 20px 60px 20px 10px;
      border-bottom: 1px solid map-get($colors, border);
    }

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }

    &.active-url {
      font-weight: 600;

      @include mobile {
        fill: map-get($colors, secondary);
        color: map-get($colors, secondary);
      }
    }
  }

  &__icon {
    @include square(18px);
  }
}
</style>
